import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAddressByDetailsQueryVariables = Types.Exact<{
  street_1: Types.Scalars['String']['input'];
  street_2?: Types.InputMaybe<Types.Scalars['String']['input']>;
  city: Types.Scalars['String']['input'];
  state: Types.Scalars['String']['input'];
  postal_code: Types.Scalars['String']['input'];
  country: Types.Scalars['String']['input'];
}>;


export type GetAddressByDetailsQuery = { __typename?: 'query_root', addresses: Array<{ __typename?: 'addresses', id: any }> };


export const GetAddressByDetailsDocument = gql`
    query getAddressByDetails($street_1: String!, $street_2: String, $city: String!, $state: String!, $postal_code: String!, $country: String!) {
  addresses(
    where: {street_1: {_eq: $street_1}, street_2: {_eq: $street_2}, city: {_eq: $city}, state: {_eq: $state}, postal_code: {_eq: $postal_code}, country: {_eq: $country}}
  ) {
    id
  }
}
    `;

/**
 * __useGetAddressByDetailsQuery__
 *
 * To run a query within a React component, call `useGetAddressByDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressByDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressByDetailsQuery({
 *   variables: {
 *      street_1: // value for 'street_1'
 *      street_2: // value for 'street_2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postal_code: // value for 'postal_code'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetAddressByDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAddressByDetailsQuery, GetAddressByDetailsQueryVariables> & ({ variables: GetAddressByDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressByDetailsQuery, GetAddressByDetailsQueryVariables>(GetAddressByDetailsDocument, options);
      }
export function useGetAddressByDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressByDetailsQuery, GetAddressByDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressByDetailsQuery, GetAddressByDetailsQueryVariables>(GetAddressByDetailsDocument, options);
        }
export function useGetAddressByDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressByDetailsQuery, GetAddressByDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddressByDetailsQuery, GetAddressByDetailsQueryVariables>(GetAddressByDetailsDocument, options);
        }
export type GetAddressByDetailsQueryHookResult = ReturnType<typeof useGetAddressByDetailsQuery>;
export type GetAddressByDetailsLazyQueryHookResult = ReturnType<typeof useGetAddressByDetailsLazyQuery>;
export type GetAddressByDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAddressByDetailsSuspenseQuery>;
export type GetAddressByDetailsQueryResult = Apollo.QueryResult<GetAddressByDetailsQuery, GetAddressByDetailsQueryVariables>;